import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { formatPriceForDisplay } from '../../../../../util/format-money';
import CheckmarkIcon from '../../../../../components/icons/CheckmarkIcon';

const FEATURES = [
  {
    label: 'Web, iOS, & Android gallery access',
    type: Boolean,
    values: [true, true],
  },
  {
    label: 'Personalized QR code signage & SMS code for easy guest onboarding',
    type: Boolean,
    values: [false, true],
  },
  {
    label: 'Bulk guest list import with scheduled invites & upload reminders',
    type: Boolean,
    values: [false, true],
  },
  {
    label: 'AI powered photo delivery to family & friends',
    type: Boolean,
    values: [false, true],
  },
  {
    label: 'Live AI-powered Slideshow',
    type: Boolean,
    values: [false, true],
  },
  {
    label: 'Photo moderation',
    type: Boolean,
    values: [false, true],
  },
  {
    label: 'Personalized photo filter & hashtag',
    type: Boolean,
    values: [false, true],
  },
  {
    label: 'Thank You cards',
    type: Boolean,
    values: [false, true],
  },
  {
    label: 'Photo & video storage',
    type: String,
    values: ['10GB', '50GB'],
  },
];

const propTypes = {
  waldofiedEventAddonItem: PropTypes.shape({
    id: PropTypes.string,
    price: PropTypes.shape({
      value: PropTypes.number.isRequired,
    }),
  }).isRequired,
  className: PropTypes.string,
};

const WaldofiedFeatureComparison = ({ waldofiedEventAddonItem, className }) => {
  const classes = classNames({
    'table-responsive': true,
    [className]: !!className,
  });

  return (
    <div className={classes}>
      <table className="table table-striped waldofied-features-table text-dark">
        <thead>
          <tr>
            <th>&nbsp;</th> {/** Actions. */}
            <th className="text-bold text-dark text-center">
              Basic <br />{' '}
              <span className="text-sm text-primary text-bold text-uppercase">
                FREE
              </span>{' '}
            </th>
            <th className="text-bold text-dark text-center">
              <span className="text-gold">Gold</span> <br />{' '}
              <span className="text-sm text-primary text-bold  text-uppercase">
                ${formatPriceForDisplay(waldofiedEventAddonItem.price.value)}
              </span>{' '}
            </th>
          </tr>
        </thead>
        <tbody>
          {FEATURES.map(feature => (
            <tr key={feature.label}>
              <td className="text-left">{feature.label}</td>
              {feature.type === Boolean ? (
                <Fragment>
                  <td>
                    {feature.values[0] ? (
                      <CheckmarkIcon color="#0d84fe" />
                    ) : (
                      <span className="text-light h1 text-extra-bold">
                        &times;
                      </span>
                    )}
                  </td>
                  <td>
                    {feature.values[1] ? (
                      <CheckmarkIcon color="#0d84fe" />
                    ) : (
                      <span className="text-light h1 text-extra-bold">
                        &times;
                      </span>
                    )}
                  </td>
                </Fragment>
              ) : (
                <Fragment>
                  <td>{feature.values[0]}</td>
                  <td>{feature.values[1]}</td>
                </Fragment>
              )}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

WaldofiedFeatureComparison.propTypes = propTypes;

export default WaldofiedFeatureComparison;
